'use strict';

var dtmTag = function () {
  /**
   * Initialize events for current page
   * @param {object} params Initial parameters as an object
   */
  var dataLayer = window.dataLayer;

  var _init = function _init(params) {
    if (params.page === 'home') _home();
    if (params.page === 'faq') _faq();
    if (params.page === 'stock') _stock();
    if (params.page === 'detail') _detail();
    if (params.page === 'form') _form(params.area);

    if (typeof params.includes !== 'undefined' && params.includes.indexOf('uspButtons') >= 0) _uspButtons();
    if (typeof params.includes !== 'undefined' && params.includes.indexOf('ctas') >= 0) _ctas();
    if (typeof params.includes !== 'undefined' && params.includes.indexOf('bannerTop') >= 0) _bannerTop();
  };

  // DTM Direct Call Rules Functions

  var _track = {
    genericClick: function genericClick(destination, locationInpage, buttonText) {
      console.log('genericClick => ' + destination + ' -- ' + locationInpage + ' -- ' + buttonText);
      dataLayer.destination = destination;
      dataLayer.locationInpage = locationInpage;
      dataLayer.buttonText = buttonText;
      _satellite.track('genericClick');
    },
    accordionExpansion: function accordionExpansion(type, text) {
      console.log('accordionExpansion => ' + type + ' -- ' + text);
      dataLayer.accordionType = type;
      dataLayer.accordionText = text;
      _satellite.track('accordionExpansion');
    },
    financeCalculator: function financeCalculator(values) {
      if (!sessionStorage.calculatorInteraction) {
        console.log('FINANCECALCULATOR\n', values);
        /* 
        [repaymentFrequency]  | (capital financiado / (numero de meses * TIN))
        --> nominal_servicios / (duracion * (tasa_base * 100))
        [loanTerm] | (Duración)
        --> duracion
        [ denomination] | (Magic Plan 3D o Crédito Clásico)
        --> descripcion
        [ interestRate] | (TIN)
        --> (tasa_base * 100)
        [deposit]| (Entrada)
        --> entrada
        [baloonPrice] | (Última cuota)
        -- ultima_cuota
        [installmentPrice] | (Precio de la Cuota)
        --> cuota_financiera
        [totalPrice]" (Precio Total)
        --> coste_total
        */
        var repaymentFrequency = utils.formatPrice(values.nominal_servicios / (values.duracion * (values.tasa_base * 100)), 2);
        var loanTerm = values.duracion;
        var denomination = values.descripcion;
        var interestRate = utils.formatPrice(salida.tasa_base * 100, 2);
        var deposit = utils.formatPrice(salida.entrada, 2);
        var baloonPrice = utils.formatPrice(salida.ultima_cuota, 2);
        var installmentPrice = utils.formatPrice(salida.cuota_financiera, 1);
        var totalPrice = utils.formatPrice(salida.coste_total, 2);
        dataLayer.financeCalculatorStep = 'start';
        dataLayer.financeTerms = repaymentFrequency + ' | ' + loanTerm + ' | ' + denomination + ' | ' + interestRate + ' | ' + deposit + ' | ' + baloonPrice + ' | ' + installmentPrice + ' | ' + totalPrice;
        console.log('dataLayer.financeTerms:\n', dataLayer.financeTerms);
        _satellite.track('financeCalculator');
        sessionStorage.setItem('calculatorInteraction', true);
      }
    },
    toggle: function toggle(type, buttonText) {
      dataLayer.toggleType = type;
      dataLayer.toggleValue = buttonText;
      _satellite.track('toggle');
    },
    search: function search(searchTerm, resultsLength) {
      dataLayer.action = 'search';
      dataLayer.searchTerm = searchTerm;
      dataLayer.searchType = 'dealer locator';
      dataLayer.searchResults = '' + resultsLength;
      _satellite.track('search');
    },
    dealerInteraction: function dealerInteraction(dealerInfo) {
      dataLayer.dealerAction = 'list';
      dataLayer.dealerAddress = dealerInfo.direccion + ', ' + dealerInfo.poblacion + '. ' + dealerInfo.provincia;
      dataLayer.dealerId = '' + dealerInfo.id;
      dataLayer.dealerName = '' + dealerInfo.nombre;
      _satellite.track('dealerInteraction');
    },
    simulatePageLoad: function simulatePageLoad(vehicleCategory, vehicleModel, vehicleId, pageName, formType, formName) {
      dataLayer.adobeAccount = 'nissanesprod';
      dataLayer.countryCode = 'ES';
      dataLayer.languageCode = 'es';
      dataLayer.brand = 'nissan';
      dataLayer.loginStatus = 'logged out';
      dataLayer.mboxActivated = 'false';
      dataLayer.genericTracking = 'true';
      dataLayer.platform = 'iberia ecommerce';
      dataLayer.timeStamp = new Date().toISOString();
      dataLayer.screenSize = getStringScreenSize();
      dataLayer.vehicleCategory = vehicleCategory;
      dataLayer.vehicleModel = vehicleModel;
      dataLayer.vehicleId = vehicleId;
      dataLayer.pageName = pageName;
      dataLayer.pageType = 'form';
      dataLayer.formType = formType;
      dataLayer.formName = formName;
      dataLayer.formCategory = 'lead';
      _satellite.track('simulatePageLoad');
    }

    // INCLUDES: Functions of elements shared in several pages

  };var _uspButtons = function _uspButtons() {
    console.log('USPs');
    var uspButtons = document.querySelectorAll('.dtm-usp-button');
    uspButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        _track.genericClick(utils.getAbsoluteURL(this.getAttribute('href')), 'feature image', this.childNodes[0].textContent);
      });
    });
  };

  var _ctas = function _ctas() {
    var ctas = document.querySelectorAll('.dtm-cta');
    ctas.forEach(function (button) {
      button.addEventListener('click', function () {
        _track.genericClick(utils.getAbsoluteURL(this.getAttribute('href')), 'action-panel', this.childNodes[0].textContent);
      });
    });
  };

  var _bannerTop = function _bannerTop() {
    console.log('bannerTop');
    document.querySelectorAll('.dtm-model-view').forEach(function (button) {
      button.addEventListener('click', function () {
        dataLayer.interactionType = 'exterior view';
        _satellite.track('panInteraction');
      });
    });
  };

  // PAGES: Functions by page

  var _home = function _home() {
    var modelButtons = document.querySelectorAll('.dtm-vehicle-button');
    modelButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        _track.genericClick(utils.getAbsoluteURL(this.getAttribute('href')), 'model-picker', this.dataset.buttonText);
      });
    });

    var platformButtons = document.querySelectorAll('.dtm-platform-button');
    platformButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        _track.genericClick(utils.getAbsoluteURL(this.getAttribute('href')), 'action-panel', this.childNodes[0].textContent);
      });
    });
  };

  var _faq = function _faq() {
    var accordions = document.querySelectorAll('.dtm-accordion');
    accordions.forEach(function (element) {
      element.addEventListener('change', function () {
        if (this.checked) {
          var siblingLabelText = this.parentNode.getElementsByTagName('label')[0].textContent.trim();
          _track.accordionExpansion('faq', siblingLabelText);
        }
      });
    });
  };

  var _stock = function _stock() {
    var filterElems = document.querySelectorAll('.dtm-filter');
    filterElems.forEach(function (element) {
      element.addEventListener('change', function () {
        dataLayer.action = 'filter';
        dataLayer.searchType = 'ecommerce';
        dataLayer.searchFilter = this.parentNode.getElementsByTagName('label')[0].textContent.trim();
        dataLayer.searchFilterValue = this.options[this.selectedIndex].childNodes[0].textContent.trim();
        _satellite.track('search');
      });
    });
    var filterOrder = document.querySelector('.dtm-filter-order');
    filterOrder.addEventListener('change', function (event) {
      dataLayer.action = 'filter', dataLayer.searchType = 'ecommerce';
      dataLayer.searchFilter = this.dataset.filterName;
      dataLayer.searchFilterValue = this.options[this.selectedIndex].childNodes[0].textContent.trim();
      _satellite.track('search');
    });
  };

  var _detail = function _detail() {
    document.querySelectorAll('.dtm-cta-bottom').forEach(function (button) {
      button.addEventListener('click', function () {
        dataLayer.destination = utils.getAbsoluteURL(this.getAttribute('href'));
        dataLayer.locationInpage = 'bottom action-panel';
        dataLayer.buttonText = this.querySelector('.label').childNodes[0].textContent.trim();
        _satellite.track('genericClick');
      });
    });
  };

  var _form = function _form(area) {
    var vehicle = {
      area: area,
      vehicleCategory: getVehicleCategory(vehicleData.dealersVehicles[0].vehicle.nseccionCB, vehicleData.dealersVehicles[0].vehicle.vcombustible),
      vehicleModel: vehicleData.dealersVehicles[0].vehicle.vdisplayModelo,
      vehicleId: vehicleData.dealersVehicles[0].vehicle.vmoiModelo
    };
    document.querySelectorAll('.dtm-input').forEach(function (input) {
      var dtmVar = input.dataset.dtmVariable;
      input.value = vehicle[dtmVar];
    });
    document.querySelectorAll('.dtm-toggle-form').forEach(function (tab) {
      tab.addEventListener('click', function () {
        _track.toggle('switch form', this.childNodes[0].textContent.trim());
      });
    });

    document.forms.formOffer.querySelectorAll('input:not([type=hidden])').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!sessionStorage.startRequestAQuoteForm) {
          _track.simulatePageLoad(vehicle.vehicleCategory, vehicle.vehicleModel, vehicle.vehicleId, 'ecommerce|' + vehicle.area + '|form - request a quote start', 'Request a quote', 'ecommerce - request a quote');
          sessionStorage.setItem('startRequestAQuoteForm', true);
        }
      });
    });

    document.forms.formSale.querySelectorAll('input:not([type=hidden])').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!sessionStorage.startEcommerceForm) {
          _track.simulatePageLoad(vehicle.vehicleCategory, vehicle.vehicleModel, vehicle.vehicleId, 'ecommerce|' + vehicle.area + '|form - PI start', 'Ecommerce', 'ecommerce - PI');
          sessionStorage.setItem('startEcommerceForm', true);
        }
      });
    });
  };

  return {
    init: _init,
    track: _track
  };
}();